﻿let body = document.querySelector('body')

const editModeClass = 'pagemode-edit'
const previewModeClass = 'pagemode-preview'

export const isInPageEditor = body.classList.contains(editModeClass)
export const isInPagePreview = body.classList.contains(previewModeClass)
export const isInVisitorsView = !isInPageEditor && !isInPagePreview